import styled from 'styled-components/macro';
import { LongText } from './LongText';

export const CodeTypographyText = styled(LongText)`
  font-family: 'Fira Code';
  word-break: break-all;
  white-space: pre-wrap;
`;
